import { Flex, Space } from 'antd'
import { FC } from 'react'
import CalculationPosition from '../../../../../../../../types/api/calculation-position'
import { getRecomendations } from '../helpers/get-recomendations'
import { StrategyCard } from './strategy-card'

interface StrategyPopoverContentProps {
    cp?: CalculationPosition
    labelName?: string
    copies?: number
    cols?: number
    quantityPerRoll?: number
}

export const StrategyPopoverContent: FC<StrategyPopoverContentProps> = ({
    cp,
    labelName,
    copies,
    cols,
    quantityPerRoll,
}) => {
    const recommendationLabel = labelName || cp?.comment || 'Этикетка'
    const recommendationCopies = copies ?? cp?.copies ?? 0
    const recommendationCols = cols ?? cp?.stampFloods ?? cp?.stamp?.floods ?? 0
    const recommendationQuantityPerRoll = quantityPerRoll ?? 0

    const recomendations = getRecomendations(
        [recommendationLabel, recommendationCopies],
        recommendationCols,
        recommendationQuantityPerRoll
    )
    return (
        <Space direction={'vertical'}>
            <Flex gap={12}>
                {recomendations.map(x => {
                    return <StrategyCard strategy={x} key={x.title} />
                })}
            </Flex>

            {/* <Flex gap={12} align={'center'}>
        <Typography.Title style={{ margin: 0 }} level={5}>
            -1 ручей
        </Typography.Title>
        <Typography.Text type={'danger'}>
            <ExclamationCircleOutlined style={{ marginRight: 8 }} />
            Время печати увеличивается
        </Typography.Text>
    </Flex> */}
            {/* <Flex gap={12}>
        {recomendations2.map(x => {
            return (
                <Card style={{ width: 170 }} key={x.title} size={'small'}>
                    <Space style={{ width: '100%' }} direction={'vertical'}>
                        <b>{x.title.replace('Стратегия ', '')}</b>
                        <div>
                            <Flex gap={24} justify={'space-between'}>
                                <span>Тираж</span> <span>{x.copies}</span>
                            </Flex>
                            <Flex gap={24} justify={'space-between'}>
                                <span>Намотка</span>{' '}
                                <span>{Math.floor(x.winding)}</span>
                            </Flex>
                            <Flex gap={24} justify={'space-between'}>
                                <span>Ручьи</span> <span>{x.cols}</span>
                            </Flex>
                            <Flex gap={24} justify={'space-between'}>
                                <span>Ролики</span>{' '}
                                <Flex vertical>
                                    {x.rolls.map(([copies, amount]) => (
                                        <span>
                                            {amount} по {Math.floor(copies)}
                                        </span>
                                    ))}
                                </Flex>
                            </Flex>
                        </div>{' '}
                        <Button
                            size={'small'}
                            title={'Сейчас при нажатии ничего не происходит'}
                        >
                            Выбрать
                        </Button>
                    </Space>
                </Card>
            )
        })}
    </Flex> */}
        </Space>
    )
}
